<template>
  <div class="top-ranking-page">
    <header class="ranking-hero">
      <button type="button" class="hero-icon back-icon" aria-label="Back" @click="$router.go(-1)"><span class="back-chevron"></span></button>
      <h1>Top Ranking</h1>
      <button type="button" class="hero-icon search-icon" aria-label="Search" @click="$router.push({ name: 'HomeSearch' })">&#xe689;</button>
      <div class="hero-filters">
        <button type="button" @click="categoryOpen = true">{{ selectedCategoryLabel }} <span>&#xe6ea;</span></button>
      </div>
    </header>

    <main class="ranking-content">
      <div class="category-tabs">
        <button
          v-for="item in categories"
          :key="item.id"
          type="button"
          :class="{ active: selectedCategoryId === item.id }"
          @click="selectCategory(item)"
        >{{ item.value }}</button>
      </div>

      <div
        class="ranking-sections"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading || !hasMore"
        infinite-scroll-distance="10"
      >
        <section class="ranking-section" v-for="section in visibleSections" :key="section.title">
          <div class="section-heading">
            <strong>{{ section.title }}</strong>
          </div>
          <div class="ranking-products">
            <article class="ranking-product" v-for="(item, index) in section.items" :key="item.goods_id || index" @click="goDetail(item.goods_id)">
              <div class="product-image">
                <img :src="imageOf(item)" @error="useFallback">
              </div>
              <strong class="product-price">${{ priceOf(item) }}</strong>
            </article>
          </div>
        </section>
        <div class="ranking-empty" v-if="!loading && !visibleSections.length">No ranking products yet</div>
        <mt-spinner v-if="loading" type="triple-bounce" color="#e93b3d"></mt-spinner>
      </div>
    </main>

    <div v-if="categoryOpen" class="category-mask" @click.self="categoryOpen = false">
      <div class="category-sheet">
        <div class="sheet-handle"></div>
        <button
          v-for="item in categories"
          :key="item.id"
          type="button"
          class="sheet-option"
          @click="selectCategory(item)"
        >
          <span>{{ item.value }}</span>
          <i :class="{ selected: selectedCategoryId === item.id }"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { searchGoodsList, getGoodsclassList } from '../../../api/homesearch'

export default {
  name: 'HomeTopRanking',
  data () {
    return {
      loading: true,
      categoryOpen: false,
      selectedCategoryId: '',
      currentPage: 0,
      maxPages: 5,
      hasMore: true,
      fallbackImage: require('../../../assets/image/no_image.jpg'),
      categories: [],
      goods: []
    }
  },
  computed: {
    selectedCategoryLabel () {
      if (!this.selectedCategoryId) return 'All categories'
      const category = this.categories.find(item => String(item.id) === String(this.selectedCategoryId))
      return category ? category.value : 'All categories'
    },
    visibleSections () {
      if (this.selectedCategoryId) {
        return [{ title: this.selectedCategoryLabel, items: this.goods.slice(0, 3) }].filter(item => item.items.length)
      }
      return this.goods.length ? [{ title: 'Top ranking products', items: this.goods }] : []
    }
  },
  created () {
    this.loadCategories()
    this.loadRanking()
  },
  methods: {
    loadCategories () {
      getGoodsclassList().then(res => {
        const list = res && res.result && res.result.class_list ? res.result.class_list : []
        this.categories = [{ id: '', value: 'All' }].concat(list.map(item => ({ id: item.id, value: item.value })))
      }).catch(() => {
        this.categories = [{ id: '', value: 'All' }]
      })
    },
    loadRanking (append) {
      if (this.loading && append) return
      const page = append ? this.currentPage + 1 : 1
      if (page > this.maxPages) {
        this.hasMore = false
        return
      }
      this.loading = true
      searchGoodsList({ cate_id: this.selectedCategoryId, sort_key: 'goods_salenum', sort_order: '', page: page, per_page: 12 }).then(res => {
        const result = res && res.result ? res.result : {}
        const list = result.goods_list || []
        this.goods = append ? this.goods.concat(list) : list
        this.currentPage = page
        this.hasMore = page < this.maxPages && (typeof result.hasmore === 'boolean' ? result.hasmore : list.length === 12)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    loadMore () {
      if (!this.loading && this.hasMore) this.loadRanking(true)
    },
    selectCategory (item) {
      this.selectedCategoryId = item.id
      this.categoryOpen = false
      this.goods = []
      this.currentPage = 0
      this.hasMore = true
      this.loading = true
      this.loadRanking()
    },
    goDetail (id) {
      if (id) this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: id } })
    },
    imageOf (item) {
      return item.goods_image_url || item.goods_img_480 || item.goods_image_format || this.fallbackImage
    },
    useFallback (event) {
      event.target.src = this.fallbackImage
    },
    priceOf (item) {
      return item.wholesalegoods_price || item.goods_promotion_price || item.goods_price || '0.00'
    }
  }
}
</script>

<style scoped lang="scss">
.top-ranking-page { min-height: 100vh; background: #f2eae7; color: #2b2928; }
.ranking-hero { position: relative; height: 8.7rem; padding: .65rem .75rem 0; box-sizing: border-box; color: #fff; background: linear-gradient(180deg, #34211e 0%, #1d0906 100%); }
.ranking-hero:after { content: ''; position: absolute; inset: 0; opacity: .08; background: radial-gradient(circle at 50% 46%, #fff 0, transparent 40%); pointer-events: none; }
.ranking-hero h1 { position: relative; z-index: 1; margin: 0; text-align: center; font-size: .92rem; line-height: 1.65rem; }
.hero-icon { position: absolute; z-index: 2; top: .68rem; width: 1.4rem; height: 1.4rem; border: 0; padding: 0; background: transparent; color: #fff; font-family: iconfont; font-size: 1.18rem; }
.back-icon { left: .68rem; }
.back-chevron { display: block; width: .62rem; height: .62rem; margin: .25rem 0 0 .22rem; border-left: .11rem solid #fff; border-bottom: .11rem solid #fff; transform: rotate(45deg); }
.search-icon { right: .68rem; }
.hero-filters { position: absolute; z-index: 2; left: 0; right: 0; bottom: .75rem; display: flex; justify-content: center; gap: .22rem; }
.hero-filters button { height: 1.6rem; padding: 0 .72rem; border: 1px solid rgba(255,255,255,.9); border-radius: .85rem; background: transparent; color: #fff; font-size: .62rem; }
.hero-filters span { margin-left: .18rem; font-family: iconfont; font-size: .55rem; }
.ranking-content { position: relative; z-index: 3; margin-top: -.05rem; border-radius: .68rem .68rem 0 0; overflow: hidden; }
.category-tabs { display: flex; overflow-x: auto; height: 2.55rem; padding: 0 .6rem; background: #f2eae7; scrollbar-width: none; }
.category-tabs::-webkit-scrollbar { display: none; }
.category-tabs button { position: relative; flex: 0 0 auto; max-width: 10rem; padding: 0 .42rem; border: 0; background: transparent; color: #777; font-size: .67rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.category-tabs button.active { color: #252525; font-weight: 700; }
.category-tabs button.active:after { content: ''; position: absolute; left: .42rem; right: .42rem; bottom: .2rem; height: .12rem; border-radius: .1rem; background: #202020; }
.ranking-sections { padding: 0 .7rem .8rem; }
.ranking-section { margin-bottom: .48rem; padding: .45rem .55rem .55rem; border-radius: .58rem; background: #fff; }
.section-heading { display: flex; align-items: center; justify-content: space-between; height: 1.15rem; color: #5a2b20; }
.section-heading strong { min-width: 0; font-size: .68rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ranking-products { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: .24rem; margin-top: .24rem; }
.ranking-product { min-width: 0; cursor: pointer; }
.product-image { position: relative; height: 5.25rem; overflow: hidden; border-radius: .2rem; background: #f1f1f1; }
.product-image img { width: 100%; height: 100%; object-fit: cover; }
.product-price { display: block; padding: .24rem .08rem 0; color: #171313; font-size: .72rem; line-height: .9rem; }
.ranking-empty { padding: 2rem 0; color: #888; text-align: center; font-size: .7rem; }
.ranking-sections > .mint-spinner { display: block; margin: 1.5rem auto; }
.category-mask { position: fixed; z-index: 20; inset: 0; background: rgba(0,0,0,.48); }
.category-sheet { position: absolute; right: 0; bottom: 0; left: 0; max-height: 82vh; overflow-y: auto; padding: .7rem 1rem 1rem; border-radius: .75rem .75rem 0 0; background: #fff; }
.sheet-handle { width: 2rem; height: .18rem; margin: 0 auto .55rem; border-radius: .2rem; background: #ddd; }
.sheet-option { display: flex; align-items: center; justify-content: space-between; width: 100%; height: 2.45rem; padding: 0; border: 0; background: transparent; color: #333; text-align: left; font-size: .68rem; }
.sheet-option span { max-width: calc(100% - 2rem); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sheet-option i { width: 1rem; height: 1rem; border: 2px solid #ddd; border-radius: 50%; box-sizing: border-box; }
.sheet-option i.selected { border-color: #292929; box-shadow: inset 0 0 0 .22rem #fff; background: #292929; }
</style>
